import React from "react";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Divider } from "../../../designSystem/Divider";
import { Label } from "../../../designSystem/Label";
import { P, Small } from "../../../designSystem/typography/Body";
import { H1, H2, H3, H4 } from "../../../designSystem/typography/Heading";
import { Em } from "../../../designSystem/typography/Em";

export const TypographyOverview = (): JSX.Element =>
{
    return (
        <>
            <Flex flexDirection="column" gap={16}>
                
                    <H1 color="gray">H1 - Lorem ipsum dolor sit amet</H1>
                
                    <H2>H2 variant medium - Lorem ipsum dolor sit amet</H2>
                    
                    <H3>H3 variant medium - Lorem ipsum dolor sit amet</H3>
                    
                    <H4>H4 variant medium - Lorem ipsum dolor sit amet</H4>

                    <H4 color="black">H4 variant medium - color:black</H4>
                    <H4 color="gray">H4 variant medium - color:gray</H4>
                    <H4 color="white" style={{ backgroundColor: 'black', padding: '4px' }}>H4 variant medium - color:white</H4>
                    <H4 color="placeholder">H4 variant medium - color:placeholder</H4>
                    <H4 color="error">H4 variant medium - color:error</H4>
                    
                <div>
                    <P>P - Body</P>
                </div>

                <Divider />

                <div>
                    <div>
                        <Small>Small - body</Small>
                    </div>

                    <div>
                        <Small>Some more small text...</Small>
                    </div>
                </div>

                <Divider />

                <div>
                    <Label>Label</Label>
                </div>

                <div>
                    <Em>Em</Em> text
                </div>

            </Flex>
        </>
    );
};